<div class="activity-item">
    <app-avatar [info]="isAdd ? userInfo: getUserInfo(item.createdById)" class="avatar"  [showTooltip]="isAdd ?false:true"></app-avatar>
    <div class="comment-detail">
        <div *ngIf="!isAdd" class="person-info">
            <div class="person-name">{{getUserInfo(item.createdById).name}}</div>
            <div class="create-time">{{ item.lastModifiedDate | date: 'MMMM d, y \'at\' h:mm a' }}</div>
        </div>

        <div *ngIf="isAdd && !isEdit" class="add-area" (click)="handleEdit()">
            Add a comment
        </div>

        <ng-container *ngIf="!isEdit && !isAdd">
            <quill-view class="remove-padding-quill" [content]="displayValue" [sanitize]="true" format="html" class="readonly-view"></quill-view>
            <div *ngIf="isSelfCommit" class="edit-action">
                <a class="action-item" (click)="handleEdit()">Edit</a>
                <nz-divider nzType="vertical"></nz-divider>
                <a class="action-item" (click)="handleRemove()">Delete</a>
            </div>
        </ng-container>


        <ng-container *ngIf="isEdit">
            <app-input-content
                #inputContentCom
                [saveLoading]="saveLoading"
                [members]="projectMembers"
                [clickToEdit]="true"
                [editorId]="isAdd ? 'add_comment' : ('edit_comment' + item.id)"
                (editSuccess)="handleSave($event)"
                (cancelEvent)="handleCancel()"
            ></app-input-content>
        </ng-container>
    </div>
</div>
